export const DataQueryParamModuleName = 'moduleName';
